@let incidentForm = reviewFormService.form;
@let findingsForm = reviewFormService.findingsForm;

<app-pan-card [header]="'Create a New Incident'" [isPageContainer]="true" pageContainerSize="xl">
  <div class="flex p-4 gap-2" [formGroup]="branchLocationForm">
    <div class="flex-1">
      <app-page-select-branch
        label="Select branch"
        placeholder="Select branch..."
        [selected]="branch()"
        (selectedChange)="onBranchChange($event)"
        [branchRequestParams]="{ isf: true }"
      />
    </div>

    <div class="flex-1">
      <app-page-select-location
        #locationSelect
        label="Select location"
        [placeholder]="!branchId() ? 'Select a branch first' : ''"
        [selected]="location()"
        (selectedChange)="onLocationChange($event)"
        [disabled]="!branchId()"
        [defaultEmpty]="true"
      />
    </div>

    <input type="hidden" formControlName="branchId" />
    <input type="hidden" formControlName="locationId" />
  </div>

  <div class="px-4 flex flex-col md:flex-row gap-2">
    <div class="flex-1">
      <app-review-form-incident-date
        [displayTimezone]="!!location()"
        [timezone]="location()?.timezone"
        [form]="incidentForm"
        [noBoundaries]="true"
      ></app-review-form-incident-date>
      <app-review-form-incident-type
        [form]="incidentForm"
        [incidentTypes]="['cancellation', 'underringing', 'walkout']"
        [exclusive]="true"
      ></app-review-form-incident-type>
      <app-review-form-template [incidentForm]="incidentForm" [form]="findingsForm" [branch]="branch()"></app-review-form-template>
      <app-review-form-value-additional-stolen-items [form]="incidentForm"></app-review-form-value-additional-stolen-items>
      <app-review-form-incident-photos
        #incidentPhotos
        [imageUrls]="reviewFormService.uniqueInstancePhotoUrls()"
        (upload)="reviewFormService.onPhotosFileUpload($event)"
      ></app-review-form-incident-photos>
      <app-review-form-transaction-reports
        #transactionReports
        [form]="incidentForm"
        [isRequired]="true"
        [imageUrls]="reviewFormService.uniqueTransactionPhotoUrls()"
        (upload)="reviewFormService.processReportsFileEvent($event)"
      ></app-review-form-transaction-reports>
      <app-review-form-extra-links [form]="incidentForm" [atLeastOneRequired]="true" [isRequired]="true"></app-review-form-extra-links>
    </div>
    <app-review-form-suspicious-incident-report-options
      class="block flex-1"
      [form]="incidentForm"
      [caseImages]="reviewFormService.caseImages()"
      [isLoadingCaseImages]="reviewFormService.isLoadingCaseImages()"
    ></app-review-form-suspicious-incident-report-options>
  </div>

  <div class="flex justify-end">
    <app-pan-button
      color="primary"
      (click)="submitReview()"
      [disabled]="!isFormValid() || isSubmitting()"
      [state]="isSubmitting() ? 'loading' : 'default'"
      data-testid="submitReview"
    >
      Submit
    </app-pan-button>
  </div>

  <app-pan-inline-alert class="my-2" type="info" icon="info">
    In accordance with the Panoptyc Data Retention Policy, photos and videos submitted through this page will be deleted after 180 days.
  </app-pan-inline-alert>
</app-pan-card>

<swal
  #success
  title="Incident submitted"
  text="Successfully submitted your review!"
  icon="success"
  [showCancelButton]="true"
  [showConfirmButton]="true"
  [focusCancel]="true"
  cancelButtonText="Go back"
  confirmButtonText="Submit another incident"
  (dismiss)="goBackHome()"
  (confirm)="reset()"
></swal>
